import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";

import { setAlert } from "../../actions/alertActions";
import { selectCountry } from "../utils/Utils";

import "../../styles/components/support/BasicSupport.scss";

class BasicSupport extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this._cancel = null;

    this.state = {
      name: "",
      phone: "",
      email: "",
      message: "",
      prefix: "",
      country: "",
      name_valid: false,
      phone_valid: false,
      email_valid: false,
      message_valid: false,
    };
  }

  componentDidMount() {
    this._mounted = true;

    this.safeSetState(
      {
        name: this.props.account.accountData?.name,
        email: this.props.account.accountData?.email
          ? this.props.account.accountData?.email
          : "",
        prefix: this.props.account.accountData?.internationalPrefix
          ? this.props.account.accountData?.internationalPrefix
          : "",
        country: this.props.account.accountData?.country
          ? this.props.account.accountData?.country
          : "",
      },
      () => {
        if (this.validateFormComponent(this.state.name, /^[A-Za-z ]+$/)) {
          this.safeSetState({
            name_valid: true,
          });
        }

        if (
          this.validateFormComponent(
            this.state.email,
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
          )
        ) {
          this.safeSetState({
            email_valid: true,
          });
        }
      }
    );
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  handleOnChange(reg, e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });

    if (this.validateFormComponent(e.target.value, reg)) {
      this.safeSetState({
        [e.target.name + "_valid"]: true,
      });
    } else {
      this.safeSetState({
        [e.target.name + "_valid"]: false,
      });
    }
  }

  handlePhoneChange(reg, e, obj) {
    this.safeSetState({
      prefix: obj.dialCode,
      phone: e,
    });

    const phoneNumber = e.replace(obj.dialCode, "");

    if (this.validateFormComponent(phoneNumber, reg)) {
      this.safeSetState({
        phone_valid: true,
      });
    } else {
      this.safeSetState({
        phone_valid: false,
      });
    }
  }

  validateFormComponent(value, reg) {
    return value.match(reg);
  }

  handleSubmit(e) {
    e.preventDefault(
      this.state.name_valid,
      this.state.email_valid,
      this.state.phone_valid,
      this.state.message_valid
    );

    if (
      this.state.name_valid &&
      this.state.email_valid &&
      this.state.phone_valid &&
      this.state.message_valid
    ) {
      axios
        .post(
          this.props.brand?.endpointToSupport || "/api/private/support",
          {
            name: this.state.name,
            email: this.state.email,
            mobile: "+" + this.state.phone,
            message: this.state.message,
          },
          {
            cancelToken: new CancelToken((c) => (this.cancel = c)),
          }
        )
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(
              I18n.t("backOffice_support_sendSuccess"),
              "primary"
            );
          }
        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.code
          )
            this.props.setAlert(I18n.t(err.response.data.message), "danger");
          if (axios.isCancel(err)) console.log("axios", err);
          else console.log(err);
        });
    } else {
      this.props.setAlert(
        I18n.t("accessManagement_warningMessageForm"),
        "danger"
      );
    }
  }

  render() {
    return (
      <div
        id="basic-support"
        className="evio-container sidebar-fix main-component "
      >
        <div id="header">
          <h3 className="selected">
            <span>
              <Translate value="backOffice_support_title" />
            </span>
          </h3>
        </div>
        <div className="main-container ">
          <Form id="support" noValidate onSubmit={(e) => this.handleSubmit(e)}>
            <div className="support-grid">
              <div className="user-info-content">
                <Form.Group className="form-field">
                  <Form.Label>
                    <Translate value="backOffice_support_nameInput" />
                  </Form.Label>
                  <Form.Control
                    tabIndex="3"
                    type="text"
                    name="name"
                    value={this.state.name}
                    onChange={this.handleOnChange.bind(this, /.*/)}
                    isValid={this.state.name_valid}
                    required
                  />
                </Form.Group>

                <Form.Group className="form-field">
                  <Form.Label>
                    <Translate value="backOffice_support_emailInput" />
                  </Form.Label>
                  <Form.Control
                    tabIndex="3"
                    type="text"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleOnChange.bind(
                      this,
                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                    )}
                    isValid={this.state.email_valid}
                    required
                  />
                </Form.Group>

                <Form.Group className="form-field" controlId="username">
                  <Form.Label>
                    <Translate value="backOffice_support_phoneInput" />
                  </Form.Label>
                  <Form.Control
                    as={PhoneInput}
                    className="phone-input"
                    tabIndex="1"
                    autoFormat={false}
                    countryCodeEditable={false}
                    inputProps={{
                      name: "mobile",
                      required: true,
                      autoFocus: true,
                      tabIndex: 2,
                    }}
                    country={selectCountry(this.state.country)}
                    inputClass={this.state.phone_valid ? " is-valid" : ""}
                    value={this.state.phone}
                    name="phone"
                    onChange={this.handlePhoneChange.bind(this, /^[0-9]+$/)}
                    isValid={this.state.phone_valid}
                    required
                  />
                </Form.Group>
              </div>

              <div className="user-message-content">
                <Form.Group controlId="exampleForm.ControlTextarea1">
                  <Form.Label>
                    <Translate value="backOffice_support_messageInput" />
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="message"
                    onChange={this.handleOnChange.bind(this, /.*/)}
                    isValid={this.state.message_valid}
                  />
                </Form.Group>
              </div>

              <div className="bottom-submit">
                <button type="submit" form="support">
                  <Translate value="backOffice_support_submit" />
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  country: state.i18n.locale,
  account: state.account,
  brand: state.app.brand,
});

export default connect(mapStateToProps, { setAlert })(BasicSupport);
